import {Form} from '../../../../../form-editor/src/core/model'

const storage = {
  load: (key: string): any | undefined => {
    let serializedState
    try {
      serializedState = localStorage.getItem(key)
    } catch (err) {
      console.error(err)
      return null
    }
    try {
      return JSON.parse(serializedState)
    } catch (err) {
      // Parsing will fail when it's not an object, so simply return the value
      return serializedState
    }
  },

  save: (key: string, value: any): void => {
    try {
      const serializedState = (typeof value === 'object') ? JSON.stringify(value) : value
      localStorage.setItem(key, serializedState)
    } catch (err) {
      console.error(err)
    }
  },

  clear: (key: string): void => {
    localStorage.removeItem(key)
  }
}

/**
 * Alternative API
 */
export class LocalStorageEntity<T> {

  constructor(private key: string) {
  }

  save = (value: T): void => {
    return storage.save(this.key, value)
  }

  load = (): T | null => {
    return storage.load(this.key)
  }

  clear = (): void => {
    storage.clear(this.key)
  }
}

export const formStorage = new LocalStorageEntity<Form>('form-editor')

